// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__zt0Ks","info":"Note_info__qANPn","note":"Note_note__Ur48H","actions":"Note_actions__26j6F"};